/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type CaseManagementDtoCaseConcluded =
  (typeof CaseManagementDtoCaseConcluded)[keyof typeof CaseManagementDtoCaseConcluded];

export type CaseManagementDtoCaseStatusValues =
  (typeof CaseManagementDtoCaseStatusValues)[keyof typeof CaseManagementDtoCaseStatusValues];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CaseManagementDtoCaseConcluded = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
} as const;

export const CaseManagementDtoCaseStatusValues = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
  COMPLETED: 'COMPLETED'
} as const;
